import { t } from '../i18n';

export function renderSuccessPage(): HTMLElement {
  const page = document.createElement('div');
  page.className = 'min-h-screen relative flex items-center justify-center px-4';

  const bgImageUrl = 'https://onboarding.openhandwerk.de/img/bg-oh.jpg';

  page.innerHTML = `
    <!-- Background -->
    <div class="fixed inset-0 z-0">
      <div class="absolute inset-0 bg-brand-800" style="background-image: url('${bgImageUrl}'); background-size: cover; background-position: top left;"></div>
      <div class="absolute inset-0 bg-gradient-to-br from-brand-900/92 via-brand-800/88 to-brand-700/85"></div>
    </div>

    <!-- Content -->
    <div class="relative z-10 w-full max-w-lg animate-scale-in text-center">
      <div class="rounded-2xl bg-white p-10 shadow-elevated relative overflow-hidden">
        <!-- Accent bar -->
        <div class="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-400 via-emerald-500 to-brand-500"></div>

        <!-- Celebration icon -->
        <div class="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-50 ring-4 ring-emerald-100 animate-bounce-in">
          <svg class="h-10 w-10 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>

        <h1 class="font-display text-2xl font-bold text-surface-800 lg:text-3xl animate-fade-in-up stagger-1">
          ${t('success.title')}
        </h1>

        <p class="mt-4 text-base leading-relaxed text-surface-500 animate-fade-in-up stagger-2">
          ${t('success.message')}
        </p>

        <div class="mt-3 text-sm text-surface-400 animate-fade-in-up stagger-3">
          Prüfen Sie Ihren Posteingang für die Zugangsdaten.
        </div>

        <a href="https://login.openhandwerk.de"
          class="oh-btn-cta mt-8 gap-2 inline-flex animate-fade-in-up stagger-4">
          ${t('success.cta')}
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
          </svg>
        </a>
      </div>

      <p class="mt-8 text-sm text-white/30">
        &copy; ${new Date().getFullYear()} ${t('footer.copyright')}
      </p>
    </div>
  `;

  return page;
}
